var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0484 18.8076C13.8408 19.1672 13.5422 19.4658 13.1826 19.6734C12.8231 19.8809 12.4152 19.9902 12 19.9902C11.5848 19.9902 11.1769 19.8809 10.8174 19.6734C10.4578 19.4658 10.1592 19.1672 9.95165 18.8076",
    stroke: "#18191B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5052 16H5.49481C4.85586 16 4.47474 15.2879 4.82917 14.7562L5.49615 13.7558C5.82469 13.263 6 12.6839 6 12.0917V8.5C6 5.18629 8.68629 2.5 12 2.5C15.3137 2.5 18 5.18629 18 8.5V12.0917C18 12.6839 18.1753 13.263 18.5038 13.7558L19.1708 14.7562C19.5253 15.2879 19.1441 16 18.5052 16Z",
    stroke: "#18191B",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.01,
    cx: 17,
    cy: 7,
    r: 0.748828,
    fill: "#FF0508",
    stroke: "white",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingEmpty);
export default __webpack_public_path__ + "static/media/RingEmpty.98dc7f9ecef30e91bd1b126fa8f58476.svg";
export { ForwardRef as ReactComponent };